@media screen and (min-width: 980px) {
  :host {
    display: block;
    margin-bottom: 10px;
  }
}

@media screen and (min-width: 980px) {
  :host(.media-gallery--dialog-open) {
    z-index: 1000;
  }
}

:host > div {
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

:host > div.desktop-media {
  display: none;
  width: 369px;
  position: relative;
}

:host(:not([dir="rtl"])) > div.desktop-media {
  margin-right: 48px;
}

:host([dir="rtl"]) > div.desktop-media {
  margin-left: 48px;
}

@media screen and (min-width: 980px) {
  :host > div.desktop-media {
    display: flex;
  }
}

:host > div.mobile-media {
  margin: 20px 0;
  justify-content: flex-start;
}

@media screen and (min-width: 980px) {
  :host > div.mobile-media {
    display: none;
  }
}

.media-content {
  position: relative;
  margin-bottom: 2px;
  width: 100%;
}

.media-image {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  width: 369px;
  height: 369px;
}

.zoom__info {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 100px 0;
}

.zoom__info-status {
  pointer-events: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  z-index: 5;
  color: #9fa0a4;
  background-color: #ffffff;
  width: 10px;
  position: absolute;
  bottom: 14.4px;
  font-size: 12px;
  line-height: 1.3333333333;
}

:host(:not([dir="rtl"])) .zoom__info-status {
  right: 15px;
}

:host([dir="rtl"]) .zoom__info-status {
  left: 15px;
}

.zoom__info-status--hovered {
  color: #333333;
}

.zoom__info-label {
  text-align: center;
  display: flex;
  font-size: 13px;
  color: #9fa0a4;
  justify-content: center;
  margin-top: 8px;
}

:host(:not([dir="rtl"])) .zoom__info-label {
  padding-left: 3px;
}

:host([dir="rtl"]) .zoom__info-label {
  padding-right: 3px;
}

.media-image__image,
.media-image__360 {
  width: inherit;
  height: inherit;
}

.media-image__image {
  cursor: pointer;
}

.media-image__360 {
  cursor: move;
}

.product-status {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  border-radius: 2px;
  color: #ffffff;
  min-height: 24px;
}

.mobile-media .product-status {
  width: 290px;
  margin-top: 40px;
}

.product-status__label {
  font-weight: bold;
  font-size: 12px;
  line-height: 1.5;
}

.thumbnails__wrapper {
  max-height: 75px;
  max-width: 369px;
  margin-top: 58px;
  display: flex;
  justify-content: center;
}

:host(:not([dir="rtl"])) .thumbnails__item {
  margin-right: 8px;
}

:host([dir="rtl"]) .thumbnails__item {
  margin-left: 8px;
}

:host(:not([dir="rtl"])) .thumbnails__item:last-of-type {
  margin-right: 0;
}

:host([dir="rtl"]) .thumbnails__item:last-of-type {
  margin-left: 0;
}

.thumbnails__item-content {
  position: relative;
  padding: 0;
  width: 55px;
  height: 55px;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  box-sizing: border-box;
}

.thumbnails__item-content *,
.thumbnails__item-content *::before,
.thumbnails__item-content *::after {
  box-sizing: inherit;
}

.thumbnails__item-content--active {
  border: 1px solid #3dcd58;
}

.thumbnails__item-image {
  max-height: 51px;
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.thumbnails__item-image--small {
  width: 29px;
  height: 29px;
}

.thumbnails__item--cta {
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

:host(:not([dir="rtl"])) .thumbnails__item--cta {
  left: 0;
}

:host([dir="rtl"]) .thumbnails__item--cta {
  right: 0;
}

.thumbnails__item-label {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.thumbnails__item-label--small {
  font-size: 10px;
  color: #9fa0a4;
  margin-top: 2px;
}

.thumbnails__item-icon {
  width: 30px;
  height: 30px;
  color: #ffffff;
}

.mobile-media__slider {
  width: 284px;
}

.mobile-media__slide {
  min-width: 284px;
  height: 284px;
}

.mobile-media__slide-image {
  width: 284px;
  height: 284px;
  position: static;
}

.mobile-media__slide-360 {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 284px;
  height: 284px;
}

.mobile-media__slide-360-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  width: 288px;
  height: 288px;
  background-color: rgba(255, 255, 255, 0.95);
}

:host(:not([dir="rtl"])) .mobile-media__slide-360-wrapper {
  left: 0;
}

:host([dir="rtl"]) .mobile-media__slide-360-wrapper {
  right: 0;
}

.mobile-media__slide-360-icon {
  width: 60px;
  height: 60px;
}

.mobile-media__slide-360-title {
  height: 24px;
  color: #3dcd58;
  font-weight: 700;
  font-size: 20px;
  margin: 0 0 60px;
}

.mobile-media__slide-video {
  position: relative;
}

.mobile-media__slide-play-btn {
  position: absolute;
  top: calc(50% - 20px);
  width: 50px;
  height: 40px;
  background-color: #ffffff;
}

:host(:not([dir="rtl"])) .mobile-media__slide-play-btn {
  left: calc(50% - 25px);
}

:host([dir="rtl"]) .mobile-media__slide-play-btn {
  right: calc(50% - 25px);
}

.mobile-media__slide-play-icon {
  position: absolute;
  top: calc(50% - 26px);
  width: 72px;
  height: 53px;
  color: #3dcd58;
}

:host(:not([dir="rtl"])) .mobile-media__slide-play-icon {
  left: calc(50% - 36px);
}

:host([dir="rtl"]) .mobile-media__slide-play-icon {
  right: calc(50% - 36px);
}

.thumbnails__qds-icon {
  color: #3dcd58;
  position: absolute;
  width: 29px;
  height: 29px;
  font-size: 29px;
  line-height: 29px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}